
import CloseIcon from '../../../assets/images/Icons/Close';
import React from 'react';
import Show from '../../Show/Show';
import { Body2Reg, Title3 } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { DesignSystemButtonWithArrow } from '../../Button/DesignSystemButtonWithArrow';
import { DropShadowMedium } from '../../DropShadows/DropShadowMedium';
import { Image,TouchableOpacity,  View } from 'react-native';
import { SPACING } from '../../../config/designSystem/Spacing';
import { isWeb } from '../../../config/designSystem/Layout';

interface CTACardProps {
    titleLabel: string;
    mainTextLabel: string;
    image?: any; // should be mandatory when image will be ready
    sizeImage: number;
    ctaLabel?: string;
    onPressCta?: () => void;
    close: boolean;
    onPressClose?: () => void;
    height?: number;
}

export const NotificationCard = ({ titleLabel, height, mainTextLabel, image, sizeImage, close, ctaLabel,onPressCta ,onPressClose}: CTACardProps) => {


  const SIZE_ICON= 16;
  return (
    <DropShadowMedium style={[isWeb && {  height: '100%'}]}>
      <View style={[{backgroundColor: COLORS.surface.contrast, borderRadius: SPACING['sp-12'], height} ]}>

        <Show when={close && !!onPressClose}>
          <View style={{position:'absolute',
            top: SPACING['sp-8'],
            right: SPACING['sp-8']}}>
            <TouchableOpacity onPress={onPressClose}>
              <CloseIcon width={SIZE_ICON} height={SIZE_ICON} color={COLORS.content['accent-dark']} />
            </TouchableOpacity>
          </View>
        </Show>
        <View style={{columnGap: SPACING['sp-12'],padding: SPACING['sp-12'], flexDirection: 'row'}}>
          <Show when={image}>
            <View style={{width: sizeImage, height: sizeImage}}>

              <Image source={image} style={{width: sizeImage, height: sizeImage}} />


            </View>
          </Show>
          <View style={{rowGap: SPACING['sp-8'],  flex:1}}>
            <Title3>{titleLabel}</Title3>
            <Body2Reg flexWrap={true}>{mainTextLabel}</Body2Reg>
            <Show when={!!ctaLabel && !!onPressCta}>
              <DesignSystemButtonWithArrow label={ctaLabel as string} onPress={onPressCta as () => void} />
            </Show>

          </View>
        </View>
      </View>
    </DropShadowMedium>

  );
};

